// DashboardVendedor.jsx

import React, { useState, useEffect } from "react";
import { Layout, Alert, Button } from "antd";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import { InfoCircleOutlined } from "@ant-design/icons";
import Navbar from "../../components/Nav/Navbar";
import ModalUbicacion from "../../components/ModalUbicacion/ModalUbicacion";
import { useUser } from "../../context/UserContext";
import { EVENTO_CAMBIAR_UBICACION } from "../../utils/geo/eventos";
import { estadoVendedor } from "../../utils/vendedor/estadoVendedor";

const { Content } = Layout;

const ClienteView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const { userLocation, setUserLocationCurrent, userData } = useUser();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 850);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 850);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleModalOk = (ubicacion) => {
    setUserLocationCurrent({ latitude: ubicacion.lat, longitude: ubicacion.lng });
    setModalVisible(false);
  };
  const handleModalCancel = () => {
    setModalVisible(false);
  };

  // Permite cambiar la ubicación desde cualquier botón de la app
  useEffect(() => {
    const abrir = () => setModalVisible(true);
    window.addEventListener(EVENTO_CAMBIAR_UBICACION, abrir);
    return () => window.removeEventListener(EVENTO_CAMBIAR_UBICACION, abrir);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!userLocation) {
        setModalVisible(true);
      } else {
        setModalVisible(false);
      }
    }, 2000);

    return () => clearTimeout(timeout);
  }, [userLocation]);

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <Content
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <Navbar />
        
        <div
          data-scroll-container
          style={{
            marginTop: isMobile ? "calc(64px + env(safe-area-inset-top))" : "calc(75px + env(safe-area-inset-top))",
            padding: isMobile ? "0 10px" : "0",
            paddingBottom: isMobile ? "calc(40px + env(safe-area-inset-bottom))" : 0,
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {userData?.role === 1 && !userData?.activado && (() => {
            const estado = estadoVendedor(userData);
            const enRevision = estado.tipo === "revision";
            return (
              <div style={{ padding: "10px 20px", background: enRevision ? "#f0fdf4" : undefined }}>
                <Alert
                  message={estado.titulo}
                  description={estado.descripcion}
                  type={estado.nivel}
                  showIcon
                  icon={enRevision ? <InfoCircleOutlined /> : undefined}
                  closable={false}
                  action={
                    estado.enlace ? (
                      <Button size="small" type="primary" onClick={() => navigate(estado.enlace)}>
                        Corregir y reenviar
                      </Button>
                    ) : undefined
                  }
                  style={
                    enRevision
                      ? { borderRadius: '12px', border: '1px solid #bcf0da', backgroundColor: '#f3faf7' }
                      : { borderRadius: '12px' }
                  }
                />
              </div>
            );
          })()}
          
          <ModalUbicacion
            visible={modalVisible}
            onOk={handleModalOk}
            onCancel={handleModalCancel}
            permitirCerrar={!!userLocation}
          />
          
          <Outlet id={id} />
          
        </div>
      </Content>
    </Layout>
  );
};
export default ClienteView;